<!--Experience: 体验中心-主页面 2020/08/26 11:56:09 Sunanguang-->

<template>
   <div class="its-experience">
     <!--Banner-->
     <banner :banners="banners" :height="height"></banner>
     <!--tabs-->
     <experience-tabs :tabs="tabs"></experience-tabs>
   </div>
</template>
<script>
import Banner from './components/Banner'
import ExperienceTabs from './components/ExperienceTabs'
export default {
  name: 'Experience',
  components: {
    Banner,
    ExperienceTabs
  },
  props: {
     item:  {
        type: Object,
        default: function () {
           return {}
        }
     }
  },
  data () {
    return {
      height: '775px',
      banners:[
        {
          key: 1,
          mainTitle:'体&nbsp;验&nbsp;产&nbsp;品',
          subTitle:'多维度',
          desc:'<div class="ma-desc-item">课前&nbsp;&nbsp;课前预习&nbsp;&nbsp;高效备课</div><div class="ma-desc-item">课中&nbsp;&nbsp;师生互动&nbsp;&nbsp;随心掌控</div><div class="ma-desc-item">课后&nbsp;&nbsp;在线作业，学情诊断</div>',
        }
      ],
      tabs:[
        {
            mainTitle:'智慧教学',
            subTitle: '海量优质资源，强大的备课工具，助力老师轻松备好课。',
            icon: 'its-icon-xuexi',
            type: 'none',
            item:{
              key: 1,
              background:false,
              videos: [
                {
                  mediaType: 'video',
                  title: '课前备课',
                  desc: '海量优质资源，强大的备课工具，助力老师轻松备好课。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-02.mp4',
                  playCover: 'images/ued-cover-01.png'
                },
                {
                  mediaType: 'video',
                  title: '课前导学',
                  desc: '个性化课前导学案，提前获取班级学情，课上针对性授课。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-03.mp4',
                  playCover: 'images/ued-cover-02.png'
                }
              ]
            }
        },
        {
            mainTitle:'智慧学习',
            subTitle: '个性化课前导学案，提前获取班级学情，课上针对性授课。',
            icon: 'its-icon-xuexi1',
            type: 'light',
            item:{
              key: 2,
              videos: [
                {
                  mediaType: 'video',
                  title: '学生抢答',
                  desc: '课上多种互动方式，让课堂气氛更活跃。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-01.mp4',
                  playCover: 'images/ued-cover-04.png'
                },
                {
                  mediaType: 'video',
                  title: '课堂答题',
                  desc: '实时发布课堂答题，即时检验教学效果。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-05.mp4',
                  playCover: 'images/ued-cover-05.png'
                },
                {
                  mediaType: 'video',
                  title: '随堂测验',
                  desc: '实时检测学习效果，精准讲解困难易错知识点，学习结果云端呈现。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-06.mp4',
                  playCover: 'images/ued-cover-06.png'
                },
                {
                  mediaType: 'video',
                  title: '作业讲解',
                  desc: '课堂查看作业结果，即刻讲评，提高课堂效率。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-07.mp4',
                  playCover: 'images/ued-cover-07.png'
                },
                {
                  mediaType: 'video',
                  title: '广播推送',
                  desc: '重点内容随时发送至学生平板，学生公平自主学习。',
                  url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-08.mp4',
                  playCover: 'images/ued-cover-08.png'
                }
              ]
            }
        },
        // {
        //     mainTitle:'智慧统计',
        //     subTitle: '快捷布置课前预习和课后复习作业，提高教师教学效率。',
        //     icon: 'its-icon-tongji',
        //     type: 'none',
        //     item:{
        //           key: 3,
        //           position:'right',
        //           images:3,
        //           icon: 'its-icon-xuexi',
        //           desc:[
        //             '<span>●</span>资源试题，随取随用',
        //             '<span>●</span>在线预习，精准教学',
        //             '<span>●</span>个人备课，轻松便捷',
        //             '<span>●</span>校本共建，人人参与'
        //           ]
        //     }
        // },
        // {
        //     mainTitle:'家校互通',
        //     subTitle: '在线作业只能批改，提高教师工作效率。',
        //     icon: 'its-icon-xuexiao',
        //     type: 'light',
        //     item:{
        //           key: 4,
        //           position:'right',
        //           images:3,
        //           icon: 'its-icon-xuexi',
        //           desc:[
        //             '<span>●</span>资源试题，随取随用',
        //             '<span>●</span>在线预习，精准教学',
        //             '<span>●</span>个人备课，轻松便捷',
        //             '<span>●</span>校本共建，人人参与'
        //           ]
        //     }
        // }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }, 500)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods:{
    handleScroll: function(){
      this.$root.setHeaderBackground()
    }
  }
}
</script>

<style scoped>
.xx-Experience {
   color: brown;
}
</style>